import React from 'react';
import ManagementPage from './ManagementPage';
export default function CompaniesPage() { return <ManagementPage resource="companies" />; }
